import React from 'react';
// Imported libs
import { Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Box } from '@chakra-ui/react';
export const OSPShortcut = (t) => {
    return (React.createElement(Accordion, null,
        React.createElement(AccordionItem
        // eventKey='OSP'
        , null,
            React.createElement(AccordionButton, null,
                React.createElement(Box, { as: 'span', layerStyle: 'menuconfig_entry' }, t('Menu.rcc_titre_OSP')),
                React.createElement(AccordionIcon, null)),
            React.createElement(AccordionPanel, null,
                React.createElement("p", null,
                    React.createElement("b", null, t('Menu.rcc_osp_cs_bold')),
                    t('Menu.rcc_osp_cs')),
                React.createElement("p", null,
                    React.createElement("b", null, t('Menu.rcc_osp_ctrl_czdt_bold')),
                    t('Menu.rcc_osp_ctrl_czdt')),
                React.createElement("p", null,
                    React.createElement("b", null, t('Menu.rcc_F7_bold')),
                    t('Menu.rcc_F7')),
                React.createElement("p", null,
                    React.createElement("b", null, t('Menu.rcc_F8_bold')),
                    t('Menu.rcc_F8')),
                React.createElement("p", null,
                    React.createElement("b", null, t('Menu.rcc_F9_bold')),
                    t('Menu.rcc_F9'))))));
};
